<template>
  <div v-if="data != null" id="card-details">
        <div id="card-img">
            <img id="img-pincipal" class="mb-2" :src="foto == '' ? this.semImagem : 'data:image/jpeg;base64,' +  foto">
        </div>
    <div id="info">
        <p class="text-center">INFORMAÇÕES</p>
    </div>
    <div class="card-details-body mt-3 ml-3 mr-3">
        <p class="mb-2" id="nameTower">{{dataFixDetail.nome}}</p>
        <p class="label-details mb-2">Status</p>
        <p id="statuspanel" class="status-pill" :style="{'background': data.colorStatus}">{{getEnumDescription(data.status)}}</p>
        <div class="d-flex w-100">
            <div class="d-flex flex-column w-50 mr-3">
                <p class="label-details">Cidade</p>
                <p class="result-details">{{dataFixDetail.cidade.nome}}</p>
            </div>
            <div class="d-flex flex-column w-50">
                <div class="d-flex flex-column">
                    <p class="label-details">Bairro</p>
                    <p class="result-details">{{ dataFixDetail.bairro }}</p>
                </div>
            </div>
        </div>
        <div class="d-flex w-100">
            <div class="d-flex flex-column w-50 mr-3">
                <p class="label-details">Rua</p>
                <p class="result-details">{{dataFixDetail.endereco}}</p>
            </div>
            <div class="d-flex flex-column w-50">
                <p class="label-details">Cep:</p>
                <p class="result-details">{{dataFixDetail.cep}}</p>
            </div>
        </div>
            <p class="label-details">Tamanho:</p>
        <p class="result-details">{{dataFixDetail.tamanho == null ? 0 : dataFixDetail.tamanho}} M²</p>
    </div>
</div>
</template>

<script>
import Panelenterprise from './panelenterprise'
export default Panelenterprise
</script>

<style scoped>
#card-details{
    width: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
    padding-bottom: 25px;
}
#img-pincipal{
    height: 100%;
    width: 100%;
    object-fit: cover;
}
#nameTower{
    color: rgb(90, 90, 90);
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
}
#info{
    height: 50px;
    width: 100%;
    font-size: 22px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
    font-family: 'Segoe UI';
}

.text-center{
    font-size: 20px;
}

.label-details{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;
}
.result-details{
    font-size: 13px;
    font-weight: bold;
    font-family: 'Segoe UI';
}

#statuspanel{
    display: flex;
    font-size: 14px !important;
    width: 100%;
    height: 30px;
    color: white;
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: rgb(212, 238, 253);
}
.card-details-body {
    font-family:'Segoe UI';
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/panelenterprise/panelenterprise.vue